/**
 * **광고·외부 링크 유입 한 번을 받아 적는다** — 보관(`utils/attribution/ad-touch`) + `ad_landed` 한 줄.
 *
 * 문서 로드 하나에 한 번만 본다(레이아웃 셋이 각자 Provider 를 두어도 모듈 표식이 거른다).
 * 새로고침은 새 로드라 다시 적는다 — 세션으로 접지 않는다(유효 클릭 판정은 admin).
 * 주소는 손대지 않는다.
 */

import { readBrowserStorage } from 'src/utils/outreach/outreach-ref';
import { parseAdTouch, storeAdTouch } from 'src/utils/attribution/ad-touch';

import { track } from './client';

let captured = false;

/** Provider 가 맥락·`page_viewed` 를 넣은 뒤 부른다 — 유입이 아니면 아무것도 안 한다 */
export function captureAdLanding(): void {
  if (captured || typeof window === 'undefined') return;
  captured = true;

  const touch = parseAdTouch(window.location.href, document.referrer || '');
  if (!touch) return;

  const local = readBrowserStorage('local');
  const { isFirstTouch } = local ? storeAdTouch(local, touch) : { isFirstTouch: false };

  track({
    name: 'ad_landed',
    type: 'action',
    props: {
      ad: touch.ad,
      utm_source: touch.utm_source,
      utm_medium: touch.utm_medium,
      utm_campaign: touch.utm_campaign,
      utm_content: touch.utm_content,
      utm_term: touch.utm_term,
      click_ids: touch.click_ids,
      landing_url: touch.landing_url,
      referrer: touch.referrer,
      is_first_touch: isFirstTouch,
    },
  });
}

/** 테스트용 — 표식을 처음으로 */
export function resetAdLandingForTests(): void {
  captured = false;
}
